module.exports = __webpack_public_path__ + "static/media/icons_Bilan d‚couverte - g‚n‚ral.9adee5cd.svg";